import { SNACKBAR_EVENTS } from '../custom-events/snackbar';
import SessionStorage from '../utils/session-storage';
import { ANNOUNCED_DISCOUNT_CODE_KEY } from '../utils/session-storage-keys';

export class DiscountCodeSnackbar {
  showDiscount = ({ code }) => {
    document.dispatchEvent(new CustomEvent(SNACKBAR_EVENTS.SHOW, {
      detail: {
        segments: [
          { text: 'Discount code ' },
          { text: code, emphasized: true },
          { text: ' is applied!' }
        ]
      }
    }));
  };

  handleDiscount = (discount) => {
    if (!discount) {
      SessionStorage.remove(ANNOUNCED_DISCOUNT_CODE_KEY);
      return;
    }

    if (SessionStorage.get(ANNOUNCED_DISCOUNT_CODE_KEY) === discount.code) {
      return;
    }

    SessionStorage.set(ANNOUNCED_DISCOUNT_CODE_KEY, discount.code);
    this.showDiscount(discount);
  };

  initialize = async () => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json'
        }
      });
      const cart = await response.json();
      const discount = cart.discount_codes?.[0];

      this.handleDiscount(discount);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to load discount code:', error);
    }
  };
}
